import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getCheckoutsLoading: false,
  getCheckoutsFailed: false,
  getCheckoutsError: false,
  getCheckoutsMessage: null,
  checkouts: [],

  getReservesCheckoutLoading: false,
  getReservesCheckoutFailed: false,
  getReservesCheckoutError: false,
  getReservesCheckoutMessage: null,
  reserves: [],

  getCheckoutCafeLoading: false,
  getCheckoutCafeFailed: false,
  getCheckoutCafeError: false,
  getCheckoutCafeMessage: null,
  checkoutCafe: {},

  postCheckoutLoading: false,
  postCheckoutFailed: false,
  postCheckoutError: false,
  postCheckoutMessage: null,
  checkoutSpecificRecord: {},

  checkout: {
    totalRecords: 0,
  },
  reserve: {
    totalRecords: 0,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_CHECKOUT_REPORT_LOADING: {
      return {
        ...state,
        getCheckoutsLoading: true,
        getCheckoutsFailed: false,
        getCheckoutsError: false,
        getCheckoutsMessage: null,
        checkouts: [],
      };
    }
    case actionTypes.GET_CHECKOUT_REPORT_SUCCESS: {
      return {
        ...state,
        getCheckoutsLoading: false,
        getCheckoutsFailed: false,
        getCheckoutsError: false,
        getCheckoutsMessage: null,
        checkout: {
          ...action.payload,
        },
        checkouts: [...action.payload.cafes],
      };
    }
    case actionTypes.GET_CHECKOUT_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCheckoutsLoading: false,
        getCheckoutsFailed: true,
        getCheckoutsError: false,
        getCheckoutsMessage: message,
      };
    }
    case actionTypes.GET_CHECKOUT_REPORT_REJECT: {
      return {
        ...state,
        getCheckoutsLoading: false,
        getCheckoutsFailed: false,
        getCheckoutsError: true,
        getCheckoutsMessage: null,
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_REPORT_LOADING: {
      return {
        ...state,
        getReservesCheckoutLoading: true,
        getReservesCheckoutFailed: false,
        getReservesCheckoutError: false,
        getReservesCheckoutMessage: null,
        reserves: [],
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_REPORT_SUCCESS: {
      return {
        ...state,
        getReservesCheckoutLoading: false,
        getReservesCheckoutFailed: false,
        getReservesCheckoutError: false,
        getReservesCheckoutMessage: null,
        reserve: {
          ...action.payload,
        },
        reserves: [...action.payload.reserves],
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getReservesCheckoutLoading: false,
        getReservesCheckoutFailed: true,
        getReservesCheckoutError: false,
        getReservesCheckoutMessage: message,
      };
    }
    case actionTypes.GET_RESERVES_CHECKOUT_REPORT_REJECT: {
      return {
        ...state,
        getReservesCheckoutLoading: false,
        getReservesCheckoutFailed: false,
        getReservesCheckoutError: true,
        getReservesCheckoutMessage: null,
      };
    }
    case actionTypes.GET_CHECKOUT_CAFE_LOADING: {
      return {
        ...state,
        getCheckoutCafeLoading: true,
        getCheckoutCafeFailed: false,
        getCheckoutCafeError: false,
        getCheckoutCafeMessage: null,
        checkoutCafe: {},
      };
    }
    case actionTypes.GET_CHECKOUT_CAFE_SUCCESS: {
      return {
        ...state,
        getCheckoutCafeLoading: false,
        getCheckoutCafeFailed: false,
        getCheckoutCafeError: false,
        getCheckoutCafeMessage: null,
        checkoutCafe: {
          ...action.payload,
        },
      };
    }
    case actionTypes.GET_CHECKOUT_CAFE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCheckoutCafeLoading: false,
        getCheckoutCafeFailed: true,
        getCheckoutCafeError: false,
        getCheckoutCafeMessage: message,
      };
    }
    case actionTypes.GET_CHECKOUT_CAFE_REJECT: {
      return {
        ...state,
        getCheckoutCafeLoading: false,
        getCheckoutCafeFailed: false,
        getCheckoutCafeError: true,
        getCheckoutCafeMessage: null,
      };
    }
    case actionTypes.POST_CHECKOUT_REPORT_LOADING: {
      return {
        ...state,
        postCheckoutLoading: true,
        postCheckoutFailed: false,
        postCheckoutError: false,
        postCheckoutMessage: null,
      };
    }
    case actionTypes.POST_CHECKOUT_REPORT_SUCCESS: {
      return {
        ...state,
        postCheckoutLoading: false,
        postCheckoutFailed: false,
        postCheckoutError: false,
        postCheckoutMessage: null,
        checkoutSpecificRecord: { checkout: true },
      };
    }
    case actionTypes.POST_CHECKOUT_REPORT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        postCheckoutLoading: false,
        postCheckoutFailed: true,
        postCheckoutError: false,
        postCheckoutMessage: message,
      };
    }
    case actionTypes.POST_CHECKOUT_REPORT_REJECT: {
      return {
        ...state,
        postCheckoutLoading: false,
        postCheckoutFailed: false,
        postCheckoutError: true,
        postCheckoutMessage: null,
      };
    }
    default:
      return state;
  }
};
